import { ApiContextType } from '../api-context';
import {
    FetchRequest,
    FetchFederationsResponse,
    Federation, UpdateFederationRequest
} from '../typings';

export const createNewFederation = (api: ApiContextType, name: string) => {
    return api.put('/federation', name)
        .then((res) => {
            if (res.status == 200 || res.status == 204) {
                return res.text().then(t => Promise.resolve(Number(t)));
            }
            return Promise.resolve(0);
        });
}
export const fetchFederations = (api: ApiContextType, request: FetchRequest): Promise<FetchFederationsResponse> => {
    return api.post(`/federations`, request)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const fetchFederation = (api: ApiContextType, id: number): Promise<Federation> => {
    return api.get(`/federation/${id}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updateFederation = (api: ApiContextType, id: number, request: UpdateFederationRequest): Promise<void> => {
    return api.post(`/federation/${id}`, request)
        .then(res => {
            if (res.status === 204) {
                return Promise.resolve();
            }
            return Promise.reject(res.status);
        });
};



